// extracted by mini-css-extract-plugin
module.exports = {"overlay-body":"OverlayBody_overlay-body__pspsn"};